export function roomid() {
    
        var result1           = '';
        var result2           = '';
        var result3           = '';
        var characters       = 'abcdefghijklmnopqrstuvwxyz';
        var charactersLength = characters.length;
        for ( var i = 0; i < 3; i++ ) {
          result1 += characters.charAt(Math.floor(Math.random() * 
     charactersLength));

     result2 += characters.charAt(Math.floor(Math.random() * 
     charactersLength));

     result3 += characters.charAt(Math.floor(Math.random() * 
     charactersLength));
    }

    let final = result1+'-'+result2+'-'+result3;
       return final;
    
    
    
}